import { companyPropertiesConstants } from '../../../constants/appConstants';
import { companyPropertiesQuery } from '../../../queries/companyQuery';
import { allTeamsQuery } from '../../../queries/teamQuery';
import { userQuery } from '../../../queries/userQuery';

import type { QueryClient } from '@tanstack/react-query';
export const settingsCardsLoader = async ({ queryClient }: { queryClient: QueryClient }) => {
	const user = await queryClient.ensureQueryData(userQuery);
	const teams = await queryClient.ensureQueryData(allTeamsQuery);
	const companyProperties = await queryClient.ensureQueryData(
		companyPropertiesQuery(user.companyAccountId, companyPropertiesConstants),
	);

	return {
		user,
		teams,
		companyProperties,
	};
};
